/**
 * AiOcrOptOutToggle — Bottone "Compila manualmente / Riattiva OCR".
 *
 * Persistenza in localStorage chiave `colucci_ai_ocr_opted_out`.
 * Esporta anche helper sync e hook useAiOcrOptOut().
 */
import { useEffect, useState } from "react";
import { ToggleLeft, ToggleRight } from "lucide-react";
import { toast } from "sonner";

const KEY = "colucci_ai_ocr_opted_out";

export function isAiOcrOptedOut() {
  try { return localStorage.getItem(KEY) === "true"; } catch (_) { return false; }
}

export function useAiOcrOptOut() {
  const [optedOut, setOptedOut] = useState(false);
  useEffect(() => { setOptedOut(isAiOcrOptedOut()); }, []);
  const set = (v) => {
    try {
      if (v) localStorage.setItem(KEY, "true");
      else localStorage.removeItem(KEY);
    } catch (_) {}
    setOptedOut(v);
  };
  return [optedOut, set];
}

export default function AiOcrOptOutToggle({ onChange }) {
  const [optedOut, setOptedOut] = useAiOcrOptOut();

  const handle = () => {
    const next = !optedOut;
    setOptedOut(next);
    onChange?.(next);
    if (next) {
      toast.success("OCR disattivato per questa sessione. I campi non verranno autocompilati.");
    } else {
      toast.success("OCR riattivato. I prossimi documenti verranno elaborati con AI.");
    }
  };

  return (
    <button
      type="button"
      onClick={handle}
      className={`inline-flex items-center gap-2 px-3 py-2 rounded-full border text-xs font-medium transition-colors ${
        optedOut
          ? "bg-zinc-100 border-zinc-300 text-zinc-700 hover:bg-zinc-200"
          : "bg-white border-amber-200 text-amber-900 hover:bg-amber-50"
      }`}
      data-testid="ai-ocr-opt-out-toggle"
      aria-pressed={optedOut}
    >
      {optedOut ? <ToggleLeft className="w-4 h-4" /> : <ToggleRight className="w-4 h-4" />}
      {optedOut ? "Riattiva OCR" : "Compila manualmente"}
    </button>
  );
}
